export class ApiValidationError extends Error {
  response: Response & {
    data?: {
      error: {
        message: string
        status?: number
      }
      errors?: {
        [key: string]: string[]
      }
    }
    statusText: string
  }

  constructor(response: ApiValidationError["response"]) {
    const message =
      response?.data?.error?.message ||
      response.statusText ||
      "Api validation Error"
    super(message)
    this.name = "ApiValidationError"
    this.response = response

    // Maintains proper stack trace (only available in V8-based engines)
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, ApiValidationError)
    }
  }
}
